import CONFIG from "../config/config";

// Public list of existing companies for the Register form's company picker →
// [{ id, name, companyType, industry, address, city, state, country, website, logo }].
// Pre-login, so no Authorization header. Registration only ever attaches to one
// of these (no free-typing/creating a company from the register form), so the
// full record is returned up front to populate the read-only detail fields
// once a company is selected.
export const listCompanies = async () => {
  const response = await fetch(`${CONFIG.BASE_URL}/api/v1/auth/companies`);
  if (!response.ok) throw new Error("Failed to load companies");
  return response.json();
};
